import peerConnection from './peerConnection'
import { publishEvent } from '../events/publishers/callEventPublisher'
import { setCall } from './sessionHandler'

export default {
  progress: event => {
    console.log('call is in progress')
  },
  failed: event => {
    publishEvent('callEnded')
    setCall(undefined)
  },
  ended: event => {
    publishEvent('callEnded')
    setCall(undefined)
  },
  confirmed: event => {
    publishEvent('callAccepted')
  },
  peerconnection: peerConnection,
}
